const steps = [
    {id: 1, title: 'About the Vault Transaction Set', name: 'about'},
    {id: 2, title: 'Vault Transaction Type', name: 'v_trans_type'},
    {id: 3, title: 'Vault Add Credit Card', name: 'add_cc'},
    {id: 4, title: 'Vault Encrypted Add Credit Card', name: 'enc_add_cc'},
    {id: 5, title: 'Vault Temporary Token Add', name: 'temp_token'},
    {id: 6, title: 'Vault Update Credit Card', name: 'update_cc'},
    {id: 7, title: 'Vault Encrypted Update CC', name: 'enc_update_cc'},
    {id: 8, title: 'Vault Delete', name: 'delete'},
    {id: 9, title: 'Vault Lookup Full', name: 'lookup_full'},
    {id: 10, title: 'Vault Lookup Masked', name: 'lookup_masked'},
    {id: 11, title: 'Vault Get Expiring', name: 'get_expiring'},
    {id: 12, title: 'Vault Is Corporate Card', name: 'corp_card'},
    {id: 13, title: 'Vault Add Token', name: 'add_token'},
    {id: 14, title: 'Vault Tokenize Credit Card', name: 'tokenize_cc'},
]

export default steps